import { SensorSpecs } from "@/types/sensor/SensorSpecs";
import { SensorCode } from "@/types/sensor/SensorCode";

export const sensorSpecs: SensorSpecs = Object.freeze({
  RS: {
    name: "Controlled Pressure",
    baseStorageKey: "reference_sensor",
    icon: "show_chart",
    defaultColor: "#eb5b0d",
  },
  ISA: {
    name: "Input Sensor A",
    baseStorageKey: "input_sensor_a",
    icon: "speed",
    defaultColor: "#192ae4",
  },
  ISB: {
    name: "Input Sensor B",
    baseStorageKey: "input_sensor_b",
    icon: "speed",
    defaultColor: "#466aa5",
  },
  ISC: {
    name: "Input Sensor C",
    baseStorageKey: "input_sensor_c",
    icon: "speed",
    defaultColor: "#004d40",
  },
  SP: {
    name: "Setpoint",
    baseStorageKey: "setpoint",
    icon: "flag",
    defaultColor: "#1b5e20",
  },
  IV: {
    name: "Intake valve",
    baseStorageKey: "intake_valve",
    icon: "login",
    defaultColor: "#827717",
  },
  EV: {
    name: "Exhaust valve",
    baseStorageKey: "exhaust_valve",
    icon: "logout",
    defaultColor: "#311b92",
  },
  IEV: {
    name: "Combined Intake and Exhaust valves",
    baseStorageKey: "combined_intake_exhaust_valves",
    icon: "call_merge",
    defaultColor: "#1b5e20",
  },
  DT: {
    name: "Device Temperature",
    baseStorageKey: "device_temperature",
    icon: "show_chart",
    // icon: "thermostat",
    defaultColor: "#b71c1c",
  },
});

export const allSensorCodes = Object.keys(sensorSpecs) as SensorCode[];
